/**
 * Deployment stages for the ASX Credits frontend.
 *
 * Values are lowercase to match the `prod` token injected at build time by
 * the KatalWebpackPlugin, which sources it from the CloudFormation `Stage` output.
 * The website CDK emits this as `stageName.toLowerCase()` (see
 * SustainabilitySolutionsHubCDK/lib/utils/setupPipelineStage.ts), so the runtime
 * value is always one of the values below.
 */
export enum STAGE {
  BETA = 'beta',
  GAMMA = 'gamma',
  PROD = 'prod',
}
